import React, { Component } from "react";
// New step components
import CampaignTypeStep from "./CampaignTypeStep";
import CampaignDetailsStep from "./CampaignDetailsStep";
import StoreSelectionStep from "./StoreSelectionStep";
import CustomerFilterStep from "./CustomerFilterStep";
import MessageTemplateStep from "./MessageTemplateStep";
import ReviewStep from "./ReviewStep";
import { getProperty } from "../../../CommonFunctions";
import Page from "../../2/Controls/Page";
import FetchProgressLoader from "./FetchProgressLoader";
import CampaignNameStep from "./CampaignNameStep";




class CreateCampaign extends Component {
  constructor(props) {
    super(props);

    const editData = props.location && props.location.state ? props.location.state.campaignData : undefined;

    this.state = {
      loading: false,
      customerFetching: false,
      fetchedCount: 0,
      expectedTotal: 0,
      totalCustomers: 0,
      currentStep: 1,
      campaignType: (editData && editData.hasOwnProperty("Type")) ? editData.Type : "",

      // Form state
      formData: {
        name: (editData && editData.hasOwnProperty("Name")) ? editData.Name : "",
        type: (editData && editData.hasOwnProperty("Type")) ? editData.Type : "",
        startDate: (editData && editData.hasOwnProperty("StartDate")) ? editData.StartDate : "",
        slot: (editData && editData.hasOwnProperty("Slot")) ? editData.Slot : "",
        slotStart: (editData && editData.hasOwnProperty("SlotStart")) ? editData.SlotStart : null,
        slotEnd: (editData && editData.hasOwnProperty("SlotEnd")) ? editData.SlotEnd : null,
        allCustomersSelected: (editData && editData.hasOwnProperty("AllCustomersSelected")) ? editData.AllCustomersSelected : true,
        specificCustomerSelected: (editData && editData.hasOwnProperty("SpecificCustomerSelected")) ? editData.SpecificCustomerSelected : false,
        smsTemplateID: (editData && editData.hasOwnProperty("SMSTemplateID")) ? editData.SMSTemplateID : "",
        emailTemplate: (editData && editData.hasOwnProperty("EmailTemplate")) ? editData.EmailTemplate : "",
        offerID: (editData && editData.hasOwnProperty("OfferID")) ? editData.OfferID : "",
        offer: (editData && editData.hasOwnProperty("offer")) ? editData.offer : "",
        smsTemplate: (editData && editData.hasOwnProperty("SmsTemplate")) ? editData.SmsTemplate : "",
        customerSelected: (editData && editData.hasOwnProperty("CustomerSelected")) ? editData.CustomerSelected : false,
        customerInDays: (editData && editData.hasOwnProperty("CustomerInDays")) ? editData.CustomerInDays : "",
        customerVisited: (editData && editData.hasOwnProperty("CustomerVisited")) ? editData.CustomerVisited : "",
        purchaseAmountSelected: (editData && editData.hasOwnProperty("PurchaseAmountSelected")) ? editData.PurchaseAmountSelected : false,
        purchaseAmountFrom: (editData && editData.hasOwnProperty("PurchaseAmountFrom")) ? editData.PurchaseAmountFrom : "",
        purchaseAmountTo: (editData && editData.hasOwnProperty("PurchaseAmountTo")) ? editData.PurchaseAmountTo : "",
        storeName: (editData && editData.hasOwnProperty("StoreName")) ? editData.StoreName : "",
        allStoresSelected: (editData && editData.hasOwnProperty("AllStoresSelected")) ? editData.AllStoresSelected : true,
        associatedStores: (editData && editData.hasOwnProperty("Stores")) ? editData.Stores : [],
        membershipSelected: (editData && editData.hasOwnProperty("MembershipSelected")) ? editData.MembershipSelected : false,
        membership: (editData && editData.hasOwnProperty("Membership")) ? editData.Membership : null,
        customerGenderSelected: (editData && editData.hasOwnProperty("CustomerGenderSelected")) ? editData.CustomerGenderSelected : false,
        customerGender: (editData && editData.hasOwnProperty("CustomerGender")) ? editData.CustomerGender : "",
        walletBalanceSelected: (editData && editData.hasOwnProperty("WalletBalanceSelected")) ? editData.WalletBalanceSelected : false,
        walletBalanceFrom: (editData && editData.hasOwnProperty("WalletBalanceFrom")) ? editData.WalletBalanceFrom : "",
        walletBalanceTo: (editData && editData.hasOwnProperty("WalletBalanceTo")) ? editData.WalletBalanceTo : "",
        specificStoreSelected: (editData && editData.hasOwnProperty("SpecificStoreSelected")) ? editData.SpecificStoreSelected : false,
        outStandingAmtSelected: (editData && editData.hasOwnProperty("OutStandingAmtSelected")) ? editData.OutStandingAmtSelected : false,
        outStandingAmtFrom: (editData && editData.hasOwnProperty("OutStandingAmtFrom")) ? editData.OutStandingAmtFrom : "",
        outStandingAmtTo: (editData && editData.hasOwnProperty("OutStandingAmtTo")) ? editData.OutStandingAmtTo : "",
        customerAgeFrom: (editData && editData.hasOwnProperty("CustomerAgeFrom")) ? editData.CustomerAgeFrom : "",
        customerAgeTo: (editData && editData.hasOwnProperty("CustomerAgeTo")) ? editData.CustomerAgeTo : "",
        customerAgeSelected: (editData && editData.hasOwnProperty("CustomerAgeSelected")) ? editData.CustomerAgeSelected : false,
        endDate: (editData && editData.hasOwnProperty("EndDate")) ? editData.EndDate : "",
        outstandingAmountTo: (editData && editData.hasOwnProperty("OutstandingAmountTo")) ? editData.OutstandingAmountTo : "",
        selectedWhatsappTemplate: (editData && editData.hasOwnProperty("SelectedWhatsappTemplate")) ? editData.SelectedWhatsappTemplate : "",

        enableEmail: (editData && editData.hasOwnProperty("EnableEmail")) ? editData.EnableEmail : false,
        enableSMS: (editData && editData.hasOwnProperty("EnableSMS")) ? editData.EnableSMS : false,
        enableWhatsapp: (editData && editData.hasOwnProperty("EnableWhatsapp")) ? editData.EnableWhatsapp : false,

        days: (editData && editData.hasOwnProperty("Days")) ? editData.Days : [],
        occurrence: (editData && editData.hasOwnProperty("Occurrence")) ? editData.Occurrence : "",
        interval: (editData && editData.hasOwnProperty("Interval")) ? editData.Interval : "",

        frequency: (editData && editData.hasOwnProperty("Frequency")) ? editData.Frequency : "One Time",
        offset: (editData && editData.hasOwnProperty("Offset")) ? editData.Offset : 0,
      },

      // Error states
      errors: {},

      // Other states
      membershipList: [],
      offerList: [],
      couponList: [],
      stores: [],
      smsTemplates: [],
      storeData: [],
      whatsappProvider: "",
      whatsappTemplates: [],

      timeSlotOptions: [
        { value: 8, label: "8:00 - 10:00" },
        { value: 10, label: "10:00 - 12:00" },
        { value: 12, label: "12:00 - 14:00" },
        { value: 14, label: "14:00 - 16:00" },
        { value: 16, label: "16:00 - 18:00" },
        { value: 18, label: "18:00 - 20:00" },
        { value: 20, label: "20:00 - 22:00" },
      ],

      channelOptions: [
        { value: "Whatsapp", label: "Whatsapp" },
        { value: "SMS", label: "SMS" },
        { value: "Email", label: "Email" },
      ],
    };

    this.editData = editData;
    this.isNullOrUndefined = this.isNullOrUndefined.bind(this);
    this.updateFormData = this.updateFormData.bind(this);
    this.fetchStoreData = this.fetchStoreData.bind(this);
    this.fetchMembershipData = this.fetchMembershipData.bind(this);
    this.fetchMessageTemplateData = this.fetchMessageTemplateData.bind(this);
    this.fetchOfferData = this.fetchOfferData.bind(this);
    this.getWhatsappProviders = this.getWhatsappProviders.bind(this);
    this.fetchWhatsappTemplates = this.fetchWhatsappTemplates.bind(this);
    this.nextStep = this.nextStep.bind(this);
    this.prevStep = this.prevStep.bind(this);
    this.validateStep = this.validateStep.bind(this);
    this.onFetchCustomers = this.onFetchCustomers.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.renderStep = this.renderStep.bind(this);
  }

  isNullOrUndefined(value) {
    return value === null || value === undefined;
  }

  updateFormData(key, value) {
    this.setState((prev) => ({
      formData: { ...prev.formData, [key]: value }
    }));

    // Clear error when field is updated
    if (this.state.errors[key]) {
      this.setState((prev) => ({
        errors: { ...prev.errors, [key]: "" }
      }));
    }
  }

  async fetchStoreData() {
    try {
      let stores = null;
      const result = await this.props.getUserStores(this.props.user.user.RegistrationID, "");
      const storeList = [];
      result.map((store) => {
        storeList.push(store);
      });
      stores = storeList;
      this.setState({ storeData: storeList });
      return stores;
    } catch (error) {
      console.error("Store data error:", error);
      this.props.getToastr("Failed to fetch store data");
      return [];
    }
  }

  async fetchMembershipData() {
    try {
      this.setState({ membershipList: this.props.config.ActiveMemberships });
    } catch (error) {
      console.error("Membership data error:", error);
      this.props.getToastr("Failed to fetch membership data");
    }
  }

  async fetchMessageTemplateData() {
    try {
      const response = await this.props.getSMSTemplateBySMSType(
        "Promotional",
        getProperty(this.props.user.store, "key")
      );
      this.setState({ smsTemplates: getProperty(response, "data") || [] });
    } catch (error) {
      // Error handling can be added if needed
    }
  }

  async fetchOfferData() {
    try {
      let offers = [],
        coupons = [];
      this.props.config.ApplicableOffers.map(m => {
        if (m.hasOwnProperty('Type') && m.Type === "Coupon") {
          coupons.push(m)
        }
        else {
          offers.push(m)
        }
      })
      this.setState({ offerList: offers, couponList: coupons });
    } catch (error) {
      console.error("offer data error:", error);
      this.props.getToastr("Failed to fetch offer data");
    }
  }

  async getWhatsappProviders() {
    try {
      const data = await this.props.getWhatsappAllProviders(this.props.registration.registration.key);

      const provider = getProperty(data, "data") ? data.data.filter((p) => p.isActive) : [];
      if (provider.length > 0) {
        this.setState({ whatsappProvider: provider[0] });
      }

      if (getProperty(data, "code") != "0") {
        return this.props.getToastr("Unable to fetch whatsapp Providers");
      }
    } catch (err) {
      console.log(err, "while fetching providers for whatsapp");
    }
  }

  async fetchWhatsappTemplates() {
    this.setState({ loading: true });
    try {
      const data = await this.props.getTemplates(getProperty(this.state.whatsappProvider, "_id"), "Promotional");
      if (getProperty(data, "code") !== "0") {
        return this.props.getToastr("Unable to fetch Promotional Templates");
      }
      this.setState({ whatsappTemplates: getProperty(data, "data") || [] });
    } catch (err) {
      console.error("Error fetching promotional templates:", err);
      this.setState({ whatsappTemplates: [] });
    } finally {
      this.setState({ loading: false });
    }
  }

  async componentDidMount() {
    let stores = await this.fetchStoreData();
    const allStores = stores;
    const formatedStores = allStores.map((store) => ({
      label: getProperty(store, "StoreName"),
      value: getProperty(store, "key"),
      address1: getProperty(store, "Address1") || "",
      address2: getProperty(store, "Address2") || "",
      state: getProperty(store, "State") || "",
      city: getProperty(store, "City") || "",
      country: getProperty(store, "Country") || "",
      pincode: getProperty(store, "PostalCode") || "",
      phoneNo: getProperty(store, "PhoneNo") || "",
      emailId: getProperty(store, "EmailID") || ""
    }));

    this.setState({ stores: formatedStores });

    this.fetchMembershipData();
    this.fetchMessageTemplateData();
    this.fetchOfferData();
    this.getWhatsappProviders();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.whatsappProvider !== this.state.whatsappProvider && this.state.whatsappProvider) {
      this.fetchWhatsappTemplates();
    }

    if (this.editData && getProperty(this.editData, "key") && prevState.smsTemplates !== this.state.smsTemplates) {
      this.fetchCampaignDetailsData();
    }
  }

  async fetchCampaignDetailsData() {
    if (!this.editData || !getProperty(this.editData, "key")) return;

    try {
      const response = await this.props.getCampaignDetails(this.editData.key);
      if (getProperty(response, "code") === "0") {
        let smsTemplate = this.state.smsTemplates.filter((s) => s.key === this.editData.SMSTemplateID).length > 0
          ? this.state.smsTemplates.filter((s) => s.key === this.editData.SMSTemplateID)[0].SMSTemplate
          : "";

        if (getProperty(this.editData, "OfferID") !== "") {
          let offer = this.state.offerList.filter((o) => o.key === this.editData.OfferID).length > 0
            ? this.state.offerList.filter((o) => o.key === this.editData.OfferID)[0]
            : null;

          if (offer) {
            smsTemplate = smsTemplate.replace("<offer>", getProperty(offer, "Name"));
            this.updateFormData("offer", getProperty(offer, "Name"));
          } else {
            let coupon = this.state.couponList.filter((o) => o.key === this.editData.OfferID).length > 0
              ? this.state.couponList.filter((o) => o.key === this.editData.OfferID)[0]
              : null;

            if (coupon) {
              smsTemplate = smsTemplate.replace("<coupon>", getProperty(coupon, "Name"));
              this.updateFormData("offer", getProperty(coupon, "Name"));
            }
          }
        }
        this.updateFormData("smsTemplate", smsTemplate);
      }
    } catch (error) {
      this.props.getToastr("Failed to fetch campaign details");
    }
  }

  
  nextStep() {
    const { currentStep, formData, stores } = this.state;

    if (!this.validateStep(currentStep)) return;

    if (currentStep === 3) {
      if (stores.length === 1) {
        this.updateFormData("allStoresSelected", true);
         if(formData.type !== "promotional"){
  this.setState({ currentStep: 6 });
        }else{
  this.setState({ currentStep: 5 });
        }
        return;
      }
    }

    if (formData.type !== "promotional" && currentStep === 4) {
      this.setState({ currentStep: 6 });
    } else {
      this.setState({ currentStep: currentStep + 1 });
    }
  }

  prevStep() {
    const { currentStep, formData, stores } = this.state;

    if (formData.type !== "promotional" && currentStep === 6) {
         if(stores.length === 1){
              this.setState({ currentStep: 3 });
      }else{
            this.setState({ currentStep: 4 });
      }
  
    } else if (currentStep === 5 && stores.length === 1) {
      this.setState({ currentStep: 3 });
    } else {
      this.setState({ currentStep: currentStep - 1 });
    }
  }

  validateStep(step) {
    const { formData, campaignType } = this.state;
    const newErrors = {};

    switch (step) {
      case 1: // Campaign Type
        if (!campaignType)
          newErrors.campaignType = "Please select a campaign type";
        break;
      case 2: // Campaign Name
        if (!formData.name.trim())
          newErrors.name = "Please provide campaign name";
        break;
      case 3: // Campaign details
        if (formData.type == "promotional") {
          if (!formData.startDate)
            newErrors.startDate = "Please select campaign start Date";
          if (formData.frequency !== "One Time" && !formData.endDate) {
            newErrors.endDate = "Please select campaign End Date";
          }
          if (formData.frequency !== "One Time" && !formData.occurrence) {
            newErrors.occurrence = "Please select occurence";
          }

          if (
            formData.frequency !== "One Time" &&
            formData.occurrence == "weekly" &&
            (!formData.days || formData.days.length < 1)
          ) {
            newErrors.days = "Please choose days";
          }
          if (
            formData.frequency !== "One Time" &&
            formData.occurrence == "custom_days" &&
            !formData.interval
          ) {
            newErrors.interval = "Please provide the interval";
          }
        }
        if (!formData.slot) {
          newErrors.slot = "Please select campaign slot";
        }
        break;
      case 4: // Store selection
        if (
          !formData.allStoresSelected &&
          (!formData.associatedStores || formData.associatedStores.length === 0)
        ) {
          newErrors.associatedStores = "Please select store";
        }
        break;
      case 6: // Message template
        if (
          !formData.enableEmail &&
          !formData.enableSMS &&
          !formData.enableWhatsapp
        ) {
          newErrors.campaignChannel = "Select Campaign Channel";
        }
        if (formData.enableWhatsapp && !formData.selectedWhatsappTemplate) {
          newErrors.whatsappTemplate = "Please select the whatsapp template";
        }
        if (formData.enableSMS && !formData.smsTemplateID) {
          newErrors.smsTemplateID = "Please select the SMS template";
        }
        if (formData.enableEmail && !formData.emailTemplate) {
          newErrors.emailTemplateID = "Please select the Email template";
        }
        break;
      default:
        break;
    }

    this.setState({ errors: newErrors });
    return Object.keys(newErrors).length === 0;
  }

  async onFetchCustomers() {
    const { formData, stores } = this.state;
    this.setState({ customerFetching: true });

    let formatedStores = [];
    if (formData.allStoresSelected) {
      stores.forEach((store) => {
        formatedStores.push(store.value);
      });
    } else {
      formData.associatedStores.forEach((store) => {
        formatedStores.push(store.value);
      });
    }

    let customers = [];
    let from = 0;
    const batchSize = 1000;
    let keepFetching = true;
    let searchAfter = null;

    this.setState({ fetchedCount: 0, expectedTotal: 0 });

    try {
      while (keepFetching) {
        const result = await this.props.getCustmerForCampaign(
          from,
          batchSize,
          formatedStores,
          formData.customerVisited,
          formData.customerInDays,
          formData.membership ? getProperty(formData.membership, "Name") : "",
          formData.customerGender,
          formData.walletBalanceFrom,
          formData.walletBalanceTo,
          formData.outStandingAmtFrom,
          formData.outStandingAmtTo,
          searchAfter
        );

        if (getProperty(result, "searchResult") && result.searchResult.length > 0) {
          customers.push(...result.searchResult);

          this.setState({ fetchedCount: customers.length });
          if (from === 0 && !searchAfter) {
            this.setState({ expectedTotal: getProperty(result, "totalItemsCount") || 0 });
          }

          const lastItem = result.searchResult[result.searchResult.length - 1];
          if (lastItem && getProperty(lastItem, "sort")) {
            searchAfter = lastItem.sort;
            from = 0;
          } else {
            from += batchSize;
          }
        } else {
          keepFetching = false;
        }
      }
    } catch (error) {
      console.error("Error while fetching customers:", error);
      keepFetching = false;
    }

    let nonVisitedCustomers = [];
    if (formData.customerVisited === "Not Visited") {
      from = 0;
      searchAfter = null;
      keepFetching = true;
      try {
        while (keepFetching) {
          const result = await this.props.getNonVisitedCustmerForCampaign(
            from,
            batchSize,
            formatedStores,
            formData.customerVisited,
            formData.customerInDays,
            formData.membership ? getProperty(formData.membership, "Name") : "",
            formData.customerGender,
            formData.walletBalanceFrom,
            formData.walletBalanceTo,
            formData.outStandingAmtFrom,
            formData.outStandingAmtTo,
            searchAfter
          );

          if (getProperty(result, "searchResult") && result.searchResult.length > 0) {
            nonVisitedCustomers.push(...result.searchResult);

            this.setState((prev) => ({
              fetchedCount: customers.length + nonVisitedCustomers.length,
              expectedTotal: prev.expectedTotal + (getProperty(result, "totalItemsCount") || 0)
            }));

            const lastItem = result.searchResult[result.searchResult.length - 1];
            if (lastItem && getProperty(lastItem, "sort")) {
              searchAfter = lastItem.sort;
              from = 0;
            } else {
              from += batchSize;
            }
          } else {
            keepFetching = false;
          }
        }
      } catch (error) {
        console.log("Failed to fetch Not visited customer", error);
        keepFetching = false;
      }
    }

    let salesCustomers = [];
    if (
      formData.purchaseAmountSelected &&
      formData.purchaseAmountFrom !== "" &&
      formData.purchaseAmountTo !== ""
    ) {
      let searchCustomersKey = [];

      customers.forEach((customer) => {
        searchCustomersKey.push(getProperty(customer, "key"));
      });

      if (nonVisitedCustomers && nonVisitedCustomers.length > 0) {
        nonVisitedCustomers.forEach((nonVisitedCustomer) => {
          searchCustomersKey.push(getProperty(nonVisitedCustomer, "key"));
        });
      }

      for (let i = 0; i < searchCustomersKey.length; i += batchSize) {
        const chunk = searchCustomersKey.slice(i, i + batchSize);
        try {
          const chunkResult = await this.props.getSalesCustomersForCampaign(
            chunk,
            formData.purchaseAmountFrom,
            formData.purchaseAmountTo
          ).then((result) => getProperty(result, "searchResult"));

          if (chunkResult && chunkResult.length > 0) {
            salesCustomers.push(...chunkResult);
          }
        } catch (error) {
          console.log(
            "Failed to fetch customer based on purchase amount:",
            error
          );
        }
      }
    }

    let finalCustomers = [];
    if (customers && customers.length > 0 && formData.purchaseAmountSelected) {
      if (salesCustomers && salesCustomers.length > 0) {
        customers.forEach((data) => {
          let obj = salesCustomers.filter((f) => getProperty(f, "key") === getProperty(data, "key"));
          if (obj.length > 0) {
            let customer = {
              "Customer Code": getProperty(data, "CustomerCode"),
              "First Name": getProperty(data, "FirstName"),
              "Last Name": !this.isNullOrUndefined(getProperty(data, "LastName"))
                ? data.LastName
                : "",
              Gender: !this.isNullOrUndefined(getProperty(data, "Gender")) ? data.Gender : "",
              "PhoneNo.": !this.isNullOrUndefined(getProperty(data, "PhoneNo")) ? data.PhoneNo : "",
              EmailID: !this.isNullOrUndefined(getProperty(data, "EmailID")) ? data.EmailID : "",
              Membership: getProperty(data, "Membership")
                ? (getProperty(data.Membership, "Name")
                  ? data.Membership.Name
                  : "")
                : "",
              "OutStanding Amount": !this.isNullOrUndefined(getProperty(data, "OutstandingAmount"))
                ? data.OutstandingAmount
                : 0,
              "Wallet Balance": !this.isNullOrUndefined(getProperty(data, "WalletBalance"))
                ? data.WalletBalance
                : 0,
              "Last Visited On": data.hasOwnProperty("LastVisitedOn")
                ? new Date(data.LastVisitedOn).toISOString().split("T")[0]
                : "",
              "Total Purchases": salesCustomers.filter(
                (f) => getProperty(f, "key") === getProperty(data, "key")
              )[0].total_sales,
            };
            finalCustomers.push(customer);
          }
        });

        if (nonVisitedCustomers && nonVisitedCustomers.length > 0) {
          nonVisitedCustomers.forEach((data) => {
            let obj = salesCustomers.filter((f) => getProperty(f, "key") === getProperty(data, "key"));
            if (obj.length > 0) {
              let customer = {
                "Customer Code": getProperty(data, "CustomerCode"),
                "First Name": getProperty(data, "FirstName"),
                "Last Name": !this.isNullOrUndefined(getProperty(data, "LastName"))
                  ? data.LastName
                  : "",
                Gender: !this.isNullOrUndefined(getProperty(data, "Gender")) ? data.Gender : "",
                "PhoneNo.": !this.isNullOrUndefined(getProperty(data, "PhoneNo"))
                  ? data.PhoneNo
                  : "",
                EmailID: !this.isNullOrUndefined(getProperty(data, "EmailID")) ? data.EmailID : "",
                Membership: getProperty(data, "Membership")
                  ? (getProperty(data.Membership, "Name")
                    ? data.Membership.Name
                    : "")
                  : "",
                "OutStanding Amount": !this.isNullOrUndefined(getProperty(data, "OutstandingAmount"))
                  ? data.OutstandingAmount
                  : 0,
                "Wallet Balance": !this.isNullOrUndefined(getProperty(data, "WalletBalance"))
                  ? data.WalletBalance
                  : 0,
                "Last Visited On": data.hasOwnProperty("LastVisitedOn")
                  ? new Date(data.LastVisitedOn).toISOString().split("T")[0]
                  : "",
                "Total Purchases": salesCustomers.filter(
                  (f) => getProperty(f, "key") === getProperty(data, "key")
                )[0].total_sales,
              };
              finalCustomers.push(customer);
            }
          });
        }
      }
    } else {
      customers.forEach((data) => {
        let customer = {
          "Customer Code": getProperty(data, "CustomerCode"),
          "First Name": getProperty(data, "FirstName"),
          "Last Name": !this.isNullOrUndefined(getProperty(data, "LastName")) ? data.LastName : "",
          Gender: !this.isNullOrUndefined(getProperty(data, "Gender")) ? data.Gender : "",
          "PhoneNo.": !this.isNullOrUndefined(getProperty(data, "PhoneNo")) ? data.PhoneNo : "",
          EmailID: !this.isNullOrUndefined(getProperty(data, "EmailID")) ? data.EmailID : "",
          Membership: getProperty(data, "Membership")
            ? (getProperty(data.Membership, "Name")
              ? data.Membership.Name
              : "")
            : "",
          "OutStanding Amount": data.hasOwnProperty("OutStandingAmount")
            ? data.OutStandingAmount
            : 0,
          "Wallet Balance": !this.isNullOrUndefined(getProperty(data, "WalletBalance"))
            ? data.WalletBalance
            : 0,
          "Last Visited On": data.hasOwnProperty("LastVisitedOn")
            ? new Date(data.LastVisitedOn).toISOString().split("T")[0]
            : "",
        };
        finalCustomers.push(customer);
      });

      if (nonVisitedCustomers && nonVisitedCustomers.length > 0) {
        nonVisitedCustomers.forEach((data) => {
          let nonVisitedCustomer = {
            "Customer Code": getProperty(data, "CustomerCode"),
            "First Name": getProperty(data, "FirstName"),
            "Last Name": !this.isNullOrUndefined(getProperty(data, "LastName")) ? data.LastName : "",
            Gender: !this.isNullOrUndefined(getProperty(data, "Gender")) ? data.Gender : "",
            "PhoneNo.": !this.isNullOrUndefined(getProperty(data, "PhoneNo")) ? data.PhoneNo : "",
            EmailID: !this.isNullOrUndefined(getProperty(data, "EmailID")) ? data.EmailID : "",
            Membership: getProperty(data, "Membership")
              ? (getProperty(data.Membership, "Name")
                ? data.Membership.Name
                : "")
              : "",
            "OutStanding Amount": data.hasOwnProperty("OutStandingAmount")
              ? data.OutStandingAmount
              : 0,
            "Wallet Balance": !this.isNullOrUndefined(getProperty(data, "WalletBalance"))
              ? data.WalletBalance
              : 0,
            "Last Visited On": data.hasOwnProperty("LastVisitedOn")
              ? new Date(data.LastVisitedOn).toISOString().split("T")[0]
              : "",
          };
          finalCustomers.push(nonVisitedCustomer);
        });
      }
    }

    if (finalCustomers.length > 0) {
      this.setState({ totalCustomers: finalCustomers.length });
      const csvContent = [
        Object.keys(finalCustomers[0]).join(","),
        ...finalCustomers.map((item) => Object.values(item).join(",")),
      ].join("\n");

      const blob = new Blob([csvContent], { type: "text/csv" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "CampaignCustomers.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.setState({ customerFetching: false });
    } else {
      this.setState({ totalCustomers: 0, customerFetching: false });
      this.props.getToastr("No customer found!");
    }
  }

  async handleSave() {
    const { formData } = this.state;

    if (this.validateStep(7)) {
      try {
        this.setState({ loading: true });

        let campaign = {
          ...(this.editData && getProperty(this.editData, "_id")
            ? { RegistrationID: getProperty(this.editData, "RegistrationID"), key: this.editData._id }
            : {}),

          Name: formData.name,
          Type: formData.type,
          StartDate: formData.startDate,
          EndDate: formData.endDate,
          Slot: Number(formData.slot),
          SlotStart: formData.slotStart,
          SlotEnd: formData.slotEnd,

          AllCustomersSelected: formData.allCustomersSelected,
          SpecificCustomerSelected: formData.specificCustomerSelected,

          SMSTemplateID: formData.smsTemplateID,
          EmailTemplate: formData.emailTemplate,
          OfferID: formData.offerID,
          Offer: formData.offer,
          SmsTemplate: formData.smsTemplate,

          CustomerSelected: formData.customerSelected,
          CustomerInDays: formData.customerInDays,
          CustomerVisited: formData.customerVisited,

          PurchaseAmountSelected: formData.purchaseAmountSelected,
          PurchaseAmountFrom: formData.purchaseAmountFrom,
          PurchaseAmountTo: formData.purchaseAmountTo,

          StoreName: formData.storeName,
          AllStoresSelected: formData.allStoresSelected,
          SpecificStoreSelected: formData.specificStoreSelected,
          Stores: formData.allStoresSelected
            ? this.state.stores
            : formData.associatedStores,

          MembershipSelected: formData.membershipSelected,
          Membership: formData.membership,

          CustomerGenderSelected: formData.customerGenderSelected,
          CustomerGender: formData.customerGender,

          WalletBalanceSelected: formData.walletBalanceSelected,
          WalletBalanceFrom: formData.walletBalanceFrom,
          WalletBalanceTo: formData.walletBalanceTo,

          OutStandingAmtSelected: formData.outStandingAmtSelected,
          OutStandingAmtFrom: formData.outStandingAmtFrom,
          OutStandingAmtTo: formData.outStandingAmtTo,

          CustomerAgeSelected: formData.customerAgeSelected,
          CustomerAgeFrom: formData.customerAgeFrom,
          CustomerAgeTo: formData.customerAgeTo,

          OutstandingAmountTo: formData.outstandingAmountTo,

          CampaignChannel: formData.campaignChannel,
          SelectedWhatsappTemplate: formData.selectedWhatsappTemplate,

          EnableWhatsapp: formData.enableWhatsapp,
          EnableSMS: formData.enableSMS,
          EnableEmail: formData.enableEmail,

          Occurrence: formData.occurrence,
          Days: formData.days,

          Frequency: formData.frequency,
          Offset: formData.offset,
          Interval: formData.interval,

          IsDeleted: false,
        };

        if (this.editData && getProperty(this.editData, "_id")) {
          await this.props.updateCampaign(campaign);
          this.props.getToastr("Campaign updated successfully");
        } else {
          await this.props.addCampaign(campaign);
          this.props.getToastr("Campaign added successfully");
        }

        
           this.props.history.push(
        "/home/campaign"
      );
      } catch (err) {
        console.error("Failed to save campaign:", err);
        this.props.getToastr(err.message || "Failed to save campaign");
      } finally {
        this.setState({ loading: false });
      }
    }
  }

  handleCancel() {
     this.props.history.push({ pathname: "/home/campaign" });
  }

  renderStep() {
    const { currentStep, campaignType, formData, errors, stores, membershipList, customerFetching, channelOptions, smsTemplates, whatsappTemplates, totalCustomers } = this.state;

    switch (currentStep) {
      case 1:
        return (
          <CampaignTypeStep
            campaignType={campaignType}
            setCampaignType={(value) => this.setState({ campaignType: value })}
            updateFormData={this.updateFormData}
            errors={errors}
          />
        );
      case 2:
        return (
          <CampaignNameStep
            setCampaignType={(value) => this.setState({ campaignType: value })}
            updateFormData={this.updateFormData}
            errors={errors}
            formData={formData}
          />
        );
      case 3:
        return (
          <CampaignDetailsStep
            formData={formData}
            campaignType={campaignType}
            updateFormData={this.updateFormData}
            timeSlotOptions={this.state.timeSlotOptions}
            errors={errors}
          />
        );
      case 4:
        return (
          <StoreSelectionStep
            formData={formData}
            updateFormData={this.updateFormData}
            stores={stores}
            errors={errors}
          />
        );
      case 5:
        return (
          <CustomerFilterStep
            formData={formData}
            updateFormData={this.updateFormData}
            membershipList={membershipList}
            customerFetching={customerFetching}
            onFetchCustomers={this.onFetchCustomers}
            errors={errors}
          />
        );
      case 6:
        return (
          <MessageTemplateStep
            formData={formData}
            updateFormData={this.updateFormData}
            channelOptions={channelOptions}
            smsTemplates={smsTemplates}
            whatsappTemplates={whatsappTemplates}
            formatedWhatsappTemplates={whatsappTemplates.map((provider) => ({
              label: getProperty(provider, "templateName"),
              value: getProperty(provider, "_id"),
            }))}
            offerList={this.state.offerList}
            couponList={this.state.couponList}
            errors={errors}
          />
        );
      case 7:
        return (
          <ReviewStep
            formData={formData}
            campaignType={campaignType}
            stores={stores}
            membershipList={membershipList}
            totalCustomers={totalCustomers}
          />
        );
      default:
        return <CampaignTypeStep />;
    }
  }

  render() {
    const { currentStep, customerFetching, fetchedCount, expectedTotal, formData } = this.state;
    const { handleCancel, handleSave, nextStep, prevStep, renderStep } = this;
    const isEdit = !!(this.editData && getProperty(this.editData, "_id"));

    const handlePageClick = (action) => {
      if (action === "save") {
        if(currentStep!==7){
           this.nextStep();
        }else{
        this.handleSave();
        }
      } else if (action === "cancel") {

         if(currentStep!==7){
           this.prevStep();
        }else{
      this.handleCancel();
        }
        
      }
    };

    const formatedWhatsappTemplates = this.state.whatsappTemplates && this.state.whatsappTemplates.map
      ? this.state.whatsappTemplates.map((provider) => ({
          label: getProperty(provider, "templateName"),
          value: getProperty(provider, "_id"),
        }))
      : [];

    return (
      <Page
        title={isEdit ? "Edit Campaign" : "Create New Campaign"}
        showSaveButton={true}
        showCancelButton={currentStep!==1}
        saveButtonText={currentStep !== 7 ? "Next" :"Save"}
        cancelButtonText={currentStep !== 7 ? "Previous" :"Cancel"}
        processing={this.state.loading}
        onClick={handlePageClick}
      >
        <FetchProgressLoader
          isLoading={customerFetching}
          count={fetchedCount}
          total={expectedTotal}
        />

        {/* Current Step Content */}
        <div style={{
          backgroundColor: "#ffffff",
          borderRadius: "8px",
          padding: "24px",
          boxShadow: "0 1px 3px 0 rgba(0, 0, 0, 0.1)"
        }}>
          {this.renderStep()}
        </div>

        
      </Page>
    );
  }
}

export default CreateCampaign;